// Front-end permissions helper — mirrors the backend `permissions.py` model.
//
// Usage:
//   import { can, MODULES } from '@/lib/permissions';
//   if (!can(user, 'leadgen', 'view')) return <Forbidden />;

export const MODULES = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'leadgen',   label: 'Lead Gen' },
  { key: 'crm',       label: 'CRM (Clients & Contacts)' },
  { key: 'proposals', label: 'Proposals & Contracts' },
  { key: 'projects',  label: 'Projects & Documents' },
  { key: 'finance',   label: 'Finance & Bookkeeping' },
  { key: 'support',   label: 'Support Hub' },
  { key: 'settings',  label: 'Settings & Users' },
];

export const ACTIONS = [
  { key: 'view',   label: 'View' },
  { key: 'create', label: 'Create' },
  { key: 'edit',   label: 'Edit' },
  { key: 'delete', label: 'Delete' },
];

export const ROLES = [
  { key: 'admin',   label: 'Administrator',   help: 'Full access to every module.' },
  { key: 'manager', label: 'Manager',         help: 'Full access to operational modules; settings is read-only.' },
  { key: 'sales',   label: 'Sales',           help: 'Full CRM / Lead Gen / Proposals; read-only Projects & Finance.' },
  { key: 'finance', label: 'Finance',         help: 'Full Finance & Bookkeeping; read-only CRM / Proposals.' },
  { key: 'viewer',  label: 'Viewer',          help: 'Read-only access to every module except Settings.' },
  { key: 'custom',  label: 'Custom',          help: 'No defaults — permissions defined per-module below.' },
];

export function can(user, module, action) {
  if (!user) return false;
  if (user.is_super_admin) return true;
  const perms = user.effective_permissions || {};
  const acts = perms[module] || [];
  return acts.includes(action);
}

export function moduleLabel(key) {
  return (MODULES.find(m => m.key === key) || {}).label || key;
}
